<template>
  <el-container class='home-container'>
    <!-- 头部区 -->
    <el-header style='height: 70px'>
      <div class='avatar' @click='index'>
        <div class='avatar_box'><img src='../assets/logo.jpg' /></div>
        <span>管理界面</span>
      </div>
      <!-- 返回首页图标 -->
      <el-link @click='index' :underline='false'
        ><i class='el-icon-s-home'></i>
      </el-link>
      <el-link @click='logout' :underline='false'>退出登录</el-link>
    </el-header>
    <!-- 页面主体区 -->
    <el-container>
      <!-- 侧边栏 -->
      <el-aside width='220px'>
        <!--  侧边栏菜单-->
        <el-menu
          background-color='#333744'
          text-color='#fff'
          active-text-color='#ffd04b'
          default-active='1'
          :router='true'
        >
          <el-menu-item index='/users'>
            <i class='el-icon-user'></i>
            <span slot='title'>用户管理</span>
          </el-menu-item>
          <el-menu-item index='/editnews'>
            <i class='el-icon-news'></i>
            <span slot='title'>新闻管理</span>
          </el-menu-item>
          <el-menu-item index='/editnotices'>
            <i class='el-icon-notebook-1'></i>
            <span slot='title'>通知管理</span>
          </el-menu-item>
          <!-- <el-menu-item index='/editpicture'>
            <i class='el-icon-picture-outline'></i>
            <span slot='title'>图片管理</span>
          </el-menu-item> -->
          <el-submenu index='1'>
            <template slot='title'>
              <i class='el-icon-picture-outline'></i>
              <span>图片管理</span>
            </template>
            <el-menu-item-group>
              <el-menu-item index='editpicture'
                ><i class='el-icon-menu'></i>顶部轮播图管理</el-menu-item
              >
              <el-menu-item index='editpicture2'
                ><i class='el-icon-menu'></i>底部轮播图管理</el-menu-item
              >
              <el-menu-item index='editpicture3'
                ><i class='el-icon-menu'></i>底部展示图管理</el-menu-item
              >
            </el-menu-item-group>
          </el-submenu>
          <el-menu-item index='/navigatList'>
            <i class='el-icon-news'></i>
            <span slot='title'>导航配置</span>
          </el-menu-item>
          <el-menu-item index='/dictionary'>
            <i class='el-icon-news'></i>
            <span slot='title'>数据字典</span>
          </el-menu-item>
          <el-menu-item index='/recommend'>
            <i class='el-icon-news'></i>
            <span slot='title'>获取注册码</span>
          </el-menu-item>
        </el-menu>
      </el-aside>

      <!-- 右侧内容主体 -->
      <el-main>
        <!-- 路由占位符 -->
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  created () {
    this.activePath = window.sessionStorage.getItem('activePath')
  },
  data () {
    return {
      // 被激活的链接地址
      activePath: ''
    }
  },
  methods: {
    logout () {
      window.sessionStorage.clear()
      this.$router.push('/login')
    },
    index () {
      this.$router.push({ name: 'home', params: { showadmin: true } })
    },
    // 保存连接的激活状态
    saveNavState (activePath) {
      window.sessionStorage.setItem('activePath', activePath)
      this.activePath = activePath
    }
  }
}
</script>

<style lang='less' scoped>
.home-container {
  height: 100%;
  background: #eaeff1;
}
.el-header {
  background-color: #333744;
  display: flex;
  justify-content: space-between;
  padding-left: 0;
  align-items: center;
  font-size: 20px;
  color: rgb(255, 255, 255);
  .avatar {
    cursor: pointer;
    display: flex;
    align-items: center;
    span {
      margin-left: 5px;
      font-weight: 800;
    }
  }
  .avatar_box {
    height: 60px;
    width: 60px;
    padding: 10px;
    margin-left: 15px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
  i {
    font-size: 30px;
  }
}
.el-link {
  color: white !important;
  margin: auto 30px;
  font-size: 16px !important;
  :hover {
    color: rgb(0, 204, 255);
  }
}
.el-aside {
  background-color: #333744;
  .el-menu {
    border-right: none;
    margin-top: 20px;
    text-align: center;
    .el-menu-item {
      padding: 0 auto;
    }
  }
}
.el-main {
  background: color #eaeff1;
}
</style>



// WEBPACK FOOTER //
// src/components/admin.vue